import { DefaultNotification } from "../default-notification/classes";
import { Address } from "../location/classes";

export class Offer {
    offerid: number = null;
    offertitle: string = null;
    offerdesc: string = null;
    offercreator: string = null;
    offercreation: string = null;
    offerstate: number = null;
    offerbillingaddress: number = null;
    billingaddress: Address;
    offerserviceaddress: number = null;
    offernumber: number = null;
    localcontact: number = null;
    customoffernote: string = null;
    commercialcontact: number = null;
    serviceaddress: Address;
    offercustomer: number = null;
    offerissue: number = null;
    offeritem: OfferItem[] = [];
    concurrencystamp: string = null;
}

export class OfferItem {
    itemid: number = null;
    itemposition: number = null;
    itemdesc: string = null;
    iteminfo: string = null;
    itemsetupcost: number = null;
    itemrentalcost: number = null;
    itempurchasecost: number = null;
    itemcontract: number = null;
    itemproduct: number = null;
    itembuildindate: string = null;
    itemfaktdate: string = null;
    itemcanceldate: string = null;
    itemlocation: number = null;
    itemterm: string = null;
    itemoffer: number = null;
    itemcount: number = null;
    itemselected: boolean = null;
    itemissue: number = null;
    offer: Offer = null;
}

export class OfferTransaction {
    id: number = null;
    name: string = null;
    result: number = null;
    icon: string = null;
    color: string = null;
    requirements: OfferStatus[] = [];
    defaultnotification: DefaultNotification[] = [];
    offertransactionattribute: OfferTransactionAttribute[] = [];
}

export class OfferStatus {
    offerstateid: number = null;
    offerstatename: string = null;
    offerstatecolor: string = null;
    offerstatedesc: string = null;
}

export class OfferTransactionAttribute {
    id: number = null;
    name: string = null;
}
